export default "__VITE_ASSET__a8Jex7OG__"